import { SHOW_INTERNAL_INFO } from '@/config/env'

export default {
  beforeMount(el) {
    if (SHOW_INTERNAL_INFO) return

    el.__vInternalPrevDisplay = el.style.display
    el.style.display = 'none'
  },

  mounted(el) {
    if (SHOW_INTERNAL_INFO) return

    if (typeof el.remove === 'function') {
      el.remove()
    } else if (el.parentNode) {
      el.parentNode.removeChild(el)
    }
  },
}
